// extracted by mini-css-extract-plugin
export default {"button":"Copy_button__9x8aN","inputContainer":"Copy_inputContainer__ya2RG"};